module.exports = __webpack_public_path__ + "img/success-case-3.4cf0abe1.png";